module.exports = __webpack_public_path__ + "img/159.04f86e60.jpg";